import request from "@utils/request";

export function getDataSameDirection(query) {
    return request({
        url: 'alert/data/same-direction',
        method: 'get',
        params: query
    })
}
